import { useEffect } from 'react';
import { useMixpanel } from 'react-mixpanel-browser';
import { Outlet } from 'react-router-dom';

import { UnsavedChangesBlocker } from '@/components/UnsavedChangesBlocker';
import { usePageInfo } from '@/hooks/usePageInfo';

export const RootLayout = () => {
    const mixpanel = useMixpanel();
    const pageInfo = usePageInfo();

    useEffect(() => {
        mixpanel?.track_pageview(pageInfo);
    }, [pageInfo, mixpanel]);

    /*
     * Mounted once here, app-wide, rather than per-page. React Router only supports a single active
     * navigation blocker, and the blocker reads global state from the unsaved-changes store, so a
     * single instance is sufficient. Rendering it in multiple pages may cause two blockers to register
     * during route transitions, which breaks the navigation.
     */
    return (
        <>
            <Outlet />
            <UnsavedChangesBlocker />
        </>
    );
};
